var React = require('react');

function ChevronLeftGallery (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.21789 11.2179L14.4438 4.99198L16 6.54818L10.5522 11.996L16 17.4438L14.4438 19L8.21789 12.7741C8.01156 12.5677 7.89566 12.2878 7.89566 11.996C7.89566 11.7042 8.01156 11.4243 8.21789 11.2179Z","fill":"white"}));
}

ChevronLeftGallery.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronLeftGallery;

ChevronLeftGallery.default = ChevronLeftGallery;
